import * as React from 'react';
import { GoogleReCaptchaProvider, withGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { IPublicFormProps, PublicForm } from './PublicForm';

const WrappedForm = withGoogleReCaptcha(PublicForm);
const scriptProps = { nonce: 'NONCE' };

export function ReCaptchaWrapper(props: IPublicFormProps) {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={props.clientKey} scriptProps={scriptProps}>
      <WrappedForm {...props} />
    </GoogleReCaptchaProvider>
  );
}
